import * as React from 'react'
import { NextSeo } from 'next-seo'

import * as url from '@boutique/url'

import { SITE_NAME, SITE_URL } from '@boutique/config'
import { DESCRIPTION, TITLE } from './constants'

export function Seo(): React.ReactElement {
  return (
    <NextSeo
      title={`${TITLE} | ${SITE_NAME}`}
      description={DESCRIPTION}
      openGraph={{
        title: `${TITLE} | ${SITE_NAME}`,
        description: DESCRIPTION,
        url: SITE_URL + url.giftIdeas().path,
        images: [
          {
            alt: TITLE,
            url: SITE_URL + '/assets/images/Ulule_Boutique.png',
          },
        ],
      }}
    />
  )
}
